<template>
  <!--
    Geef de afbeelding expliciet als slot-inhoud mee, niet via de `image`-prop.
    VAvatar rendert `props.image` alléén wanneer er geen default-slot is
    (VAvatar.js: `!slots.default ? props.image ? <VImg/> : …`), en een slot met
    v-if erin telt gewoon als slot. Met `:image` erop zou dus iedereen mét
    profielfoto een lege cirkel krijgen.
  -->
  <v-avatar
    :size="size"
    :class="['participant-avatar', { 'participant-avatar--initials': !photo }]"
    :style="{ '--participant-avatar-size': `${size}px` }"
  >
    <v-img
      v-if="photo"
      :src="photo"
      :alt="fullName"
      cover
      @error="broken = true"
    ></v-img>
    <span v-else class="participant-avatar__initials">{{ initials }}</span>
  </v-avatar>
</template>

<script>
import config from "@/config";
import { fullNameFor, initialsFor } from "@/util/participants";

export default {
  name: "ParticipantAvatar",

  props: {
    person: { type: Object, default: null },
    size: { type: Number, default: 40 },
  },

  data: () => ({
    // Een profielfoto die niet laadt (verwijderd bestand, oude bestandsnaam)
    // valt terug op de initialen in plaats van een lege cirkel achter te laten.
    broken: false,
  }),

  computed: {
    photo() {
      const file = this.person && this.person.profilepicture;
      if (!file || this.broken) return null;

      return `${config.url.cdn}/users/avatars/${file}`;
    },

    fullName() {
      return fullNameFor(this.person);
    },

    // De terugval is de initialen, niet het generieke silhouet dat de oude
    // dialogen gebruikten: een rij identieke silhouetten zegt niets over wie
    // er meedoet.
    initials() {
      return initialsFor(this.person);
    },
  },

  watch: {
    // Een nieuwe persoon in dezelfde avatarplek verdient een eigen poging.
    "person.user_id"() {
      this.broken = false;
    },
  },
};
</script>
